var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-login',{on:{"success":_vm.routeForward,"error":function($event){_vm.error = $event}}}),_c('b-error-alert',{attrs:{"value":!!_vm.error,"message":_vm.$t('login_error')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }